<template>
    <modal id="finance-account-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('finance_accounts')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/finance-accounts`'
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('type')"
                        v-model="formData.type"
                        list-value-field="value"
                        :options="typeOptions"
                        :error-message="$errorMessage(errors, 'type')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('name')"
                        :placeholder="$placeholder('name')"
                        v-model="formData.name"
                        :required="true"
                        :error-message="$errorMessage(errors, 'name')">
                    </app-form-group>
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('bank')"
                        list-value-field="name"
                        v-model="formData.bank"
                        :chooseLabel="$t('bank')"
                        :error-message="$errorMessage(errors, 'bank')"
                        :fetch-url="`${TENANT_BASE_URL}app/finance/list-bank`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('branch')"
                        :placeholder="$placeholder('branch')"
                        v-model="formData.branch_name"
                        :error-message="$errorMessage(errors, 'branch_name')">
                    </app-form-group>
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="number"
                        :label="$t('open_balance')"
                        :placeholder="$placeholder('open_balance')"
                        v-model="formData.balance"
                        :required="true"
                        :error-message="$errorMessage(errors, 'balance')">
                    </app-form-group>
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('currency_symbol')"
                        :placeholder="$placeholder('currency_symbol')"
                        v-model="formData.currency_symbol"
                        :error-message="$errorMessage(errors, 'currency_symbol')">
                    </app-form-group>
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('audit_date')"
                        :placeholder="$placeholder('audit_date')"
                        v-model="formData.audit_date"
                        :error-message="$errorMessage(errors, 'audit_date')">
                    </app-form-group>
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="color"
                        :label="$t('color')"
                        :placeholder="$placeholder('color')"
                        v-model="formData.color"
                        :error-message="$errorMessage(errors, 'color')">
                    </app-form-group>
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('remark')"
                        :placeholder="$textAreaPlaceHolder('remark')"
                        v-model="formData.remark"
                        :text-area-rows="5"
                        :error-message="$errorMessage(errors, 'remark')">
                    </app-form-group>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../common/Helper/Support/FormHelper";

export default {
    name: "FinanceAccountCreate",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            formData: {
                id: null,
                name: '',
                balance: '',
                bank: '',
                audit_date: '',
                branch_name: '',
                type: 'banking',
                currency_symbol: '¥',
                color: '#32a866',
                remark: ''
            },
            typeOptions: [
                {id: 'cash', value: this.$t('cash')},
                {id: 'banking', value: this.$t('banking')},
                {id: 'credit', value: this.$t('credit')},
            ]
        }
    },
    methods: {
        resetForm() {
            this.formData = {
                id: null,
                name: '',
                balance: '',
                bank: '',
                audit_date: '',
                branch_name: '',
                type: 'banking',
                currency_symbol: '¥',
                color: '#32a866',
                remark: ''
            };
            this.errors = {};
        },
        getFinanceAccount() {
            this.resetForm();
            this.$axios.get(this.selectedUrl)
                .then(response => {
                    this.formData = Object.assign({}, this.formData, response.data);
                })
                .catch(error => {
                    this.$toastError(error.message);
                });
        },
        submitData() {
            this.loading = true;

            let url      = this.$refs.form.dataset['url'];
            let formData = formDataAssigner(new FormData, this.formData);

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.loading = true;

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            $('#finance-account-modal').modal('hide');
            this.resetForm();
            this.$emit('input', false);
            this.toastAndReload(data.message, 'finance-account-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData = Object.assign({}, this.formData, response.data);
        },
    }
}
</script>
